import { gql } from '@apollo/client';

export const STATS = gql`
  query Stats {
    stats {
      days
      assetsUpcoming
      assetsSoldCount
      assetsSoldPrice
    }
  }
`;
